import React, { useState, useEffect } from "react";
import "../styles/home.css";
import { Container, Row, Col } from "reactstrap";
import heroVideo from "../assets/images/video.mp4";
import worldImg from "../assets/images/world.png";
import experienceImg from "../assets/images/feedback.png";
import Subtitle from "../components/shared/Subtitle";
import SearchBar from "../components/shared/SearchBar";
import ServiceList from "../components/Services/ServiceList";
import FeaturedTourList from "../components/Featured-tours/FeaturedTourList";
import MasonryImagesGallery from "../components/Image-gallery/MasonryImagesGallery";
import Testimonials from "../components/Testimonial/Testimonials";
import Newsletter from "../components/shared/Newsletter";

const Home = () => {
  const [memoriesIndex, setMemoriesIndex] = useState(0);
  const [memories] = useState([
    "Welcome To Parth Vacations",
    "Traveling opens the door to creating 'memories'",
    "Explore new places and create 'experiences'",
    "Discover cultures and embrace 'diversity'",
    // Add more phrases as needed
  ]);
  const [colors] = useState(["#2015ba", "#2015ba", "#2015ba", "#2015ba"]); // Array of colors for text

  useEffect(() => {
    const interval = setInterval(() => {
      setMemoriesIndex((prevIndex) =>
        prevIndex === memories.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // Change text every 5 seconds (5000 milliseconds)

    return () => clearInterval(interval);
  }, [memories.length]);

  const currentColor = colors[memoriesIndex % colors.length]; // Cycle through colors based on index

  return (
    <>
      <section>
        <Container>
          <Row>
            <Col lg="20">
              <div className="hero_img-box">
                <video src={heroVideo} alt="" autoPlay muted loop />
              </div>
            </Col>
            <Col lg="15">
              <div className="hero_content">
                <div className="hero_subtitle d-flex align-items-center">
                  <Subtitle subtitle={"Travel With Smile"} />
                </div>
                <h1 style={{ color: currentColor }}>
                  {memories[memoriesIndex]}
                </h1>
                <p>
                  Welcome to Parth Vacations, where every journey is crafted to create lasting memories. As a premier travel company, we specialize in delivering exceptional travel experiences tailored to your unique desires and preferences. Whether you're seeking a relaxing beach getaway, a thrilling adventure, or a culturally immersive experience, Parth Vacations has the perfect itinerary for you.
                </p>
              </div>
            </Col>
            
          </Row>
        </Container>
      </section>
      <section>
        <Container>
          <Row>
            <Col lg="12" className="mb-5">
              <h2 className="featured_tour-title">Explore Our Packages</h2>
            </Col>
            <FeaturedTourList />
          </Row>
        </Container>
      </section>
      <section>
        <Container>
          <Row>
            <Col lg="3">
              <h5 className="services_subtitle">What we serve</h5>
              <h2 className="service_title">We offer our best service</h2>
            </Col>
            <ServiceList />
          </Row>
        </Container>
      </section>
      <section>
        <Container>
          <Row>
          </Row>
        </Container>
      </section>
      <section>
        <Container>
          <Row>
            <Col lg="12">
              <Subtitle subtitle={"Gallery"} />
              <h2 className="gallery_title">
                Visit our customers tour gallery
              </h2>
            </Col>
            <Col lg="12">
              <MasonryImagesGallery />
            </Col>
          </Row>
        </Container>
      </section>
      <section>
        <Container>
          <Row>
            <Col lg="12">
            </Col>
            <Col lg="12">
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Home;
